import React from 'react';
import './About.css';

const About = () => {
  const partners = [
    'SHOWJAM Group', 'Netlify', 
    'Microsoft Azure', 'Google.org', 
  ];

  const stats = [
    { number: '1st', desc: 'AI disaster platform in the Caribbean' },
    { number: '10x', desc: 'Faster than traditional response' },
    { number: '95%', desc: 'Of donations reach victims' },
    { number: '44M', desc: 'Caribbean residents this can serve' }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-text">
            <h2>Caribbean's First AI Disaster Platform</h2>
            <p>
              Hurricane Melissa devastated Jamaica on October 28, 2025—the strongest hurricane 
              to ever hit the island. 50,000 people displaced. 500,000 without power. Traditional 
              aid taking too long.
            </p>
            
            <p>
              We built <strong>MelissaJamaica.org</strong> to prove that technology can save lives 
              in climate-vulnerable communities. Using artificial intelligence, we've transformed 
              disaster response from a slow, reactive process into rapid, data-driven intervention.
            </p>
            
            <h3>Leadership</h3>
            <div className="leader-profile">
              <div className="leader-photo">👤</div>
              <div className="leader-details">
                <h4>Raymond Pryce</h4>
                <p><strong>Chief Operations Officer, ENVIROTEK Group</strong></p>
                <p>
                  Raymond Pryce is an Environmental Scientist with 30 years combined experience in
Academia, and International Consulting. He has worked in various capacities across the
public and private sector in Jamaica and served as a Legislator representing the
constituency of Northeastern St Elizabeth. Throughout his career Raymond has always
shown leadership on issues pertaining to Climate Change Mitigation, Forest Conservation
and harmonizing the need for economic growth and the sustainable use of natural resources
to achieve development.
                </p>
              </div>
            </div>

            <h3>Partners</h3>
            <div className="partners-list">
              {partners.map((partner, index) => (
                <span key={index} className="partner-badge">{partner}</span>
              ))}
            </div>
          </div>
          
          <div className="about-stats">
            {stats.map((stat, index) => (
              <div key={index} className="stat-box">
                <div className="stat-big">{stat.number}</div>
                <div className="stat-desc">{stat.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
